import React, { useState, useEffect } from 'react';
import MenuBar from './menu/MenuBar';
import {
    Form, Card,
    Divider, Input,
    Radio, Select,
    DatePicker, Button, Modal,
    notification, message
} from 'antd';
import { format } from '../App';
import { getNamalData, postData, getOptionDriver } from '../data/allfunction';
import { useSelector, useDispatch } from "react-redux";
import { delUser, setUser } from '../app/features/user/userSlice';
import { useHistory } from 'react-router-dom';
import { db } from '../data/firebase'
import moment from 'moment';
import MakeDocLong from './pdf/MakeDocLong';
const ip = process.env.REACT_APP_IP


const SellShot = () => {
    const { token, retoken, user, user_id } = useSelector(state => {
        return state.user
    })
    const dispatch = useDispatch()
    const history = useHistory()
    const { Option } = Select;
    const [form] = Form.useForm();
    const [register, setregister] = useState(0)
    const [vat, setvat] = useState(0)
    const [total_premuim, settotal_premuim] = useState(0)
    const [modalsave, setmodalsave] = useState(false)



    const [o_name, seto_name] = useState('')
    const [o_tel, seto_tel] = useState('')
    const [o_type, seto_type] = useState('')
    const [o_make, seto_make] = useState('')
    const [o_plate, seto_plate] = useState('')
    // const [o_color, seto_color] = useState('')
    // const [o_power, seto_power] = useState('')
    const [o_engine, seto_engine] = useState('')
    const [o_chassis, seto_chassis] = useState('')
    // const [o_weight, seto_weight] = useState(0)
    const [dayCover, setDayCover] = useState('')






    const [listData, setlistData] = useState([])
    const [emp_paid, setemp_paid] = useState(0)
    const [premuim, setpremuim] = useState(0)
    const [provice, setprovice] = useState([])
    const [dist, setdist] = useState([])
    const [proviceid, setproviceid] = useState(null)

    const [proviceSelect, setproviceSelect] = useState('')
    const [distSelect, setdistSelect] = useState('')
    const [villageSelect, setvillageSelect] = useState('')




    const [startCover, setstartCover] = useState()
    const [endCover, setendCover] = useState()
    const [sent_startCover, setsent_startCover] = useState('')
    const [sent_endCover, setsent_endCover] = useState('')

    const [cover, setcover] = useState('')
    const [option, setOption] = useState(0)

    const [datasentPDF, setdatasentPDF] = useState(0)
    const [no, setno] = useState(0)
    const [modalShowPolicy, setmodalShowPolicy] = useState(false)

    const [loadingPDF, setloadingPDF] = useState(false)

    const [thirdcover_option, setthirdcover_option] = useState([])
    const [drivercover_option, setdrivercover_option] = useState([])

    const [dataDriver, set_dataDriver] = useState([])

    const [typedriver, set_typedriver] = useState(null)
    const dateFormat = 'DD-MM-YYYY HH:mm:ss'

    function onChange_timestart(value, dateString) {
        setstartCover(moment(value).format(dateFormat))
        setsent_startCover(value)
    }
    function onChange_timeend(value, dateString) {
        setendCover(moment(value).format(dateFormat))
        setsent_endCover(value)
    }
    const onChange_dist = (e) => {
        let dist = JSON.parse(e)
        // console.log(dist.dist_name)
        setdistSelect(dist.dist_name)
    }
    function onChange_pro(p) {
        let pro = (JSON.parse(p))
        setproviceid(pro.provice_id)
        setproviceSelect(pro.provice_name)
        // setdist([])
    }
    const submitForm = (e) => {
        setmodalsave(true)

    }
    //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນບຸກຄຸນທີສາມ
    const getOptionThirtpaty = () => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        fetch(ip + "sell_online/cover_third_tariff", requestOptions)
            .then(response => response.json())
            .then(result => {
                setthirdcover_option(result.data.data)
            })
            .catch(error => console.log('error', error));
    }



    function createPolicy() {
        setmodalsave(false)
        let link = `${ip}sell_online/short`
        const dataSetForGet = {
            o_name: o_name,
            // o_address: o_address,
            o_address: `${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`,
            o_tel: o_tel,
            o_type: o_type,
            o_make: o_make,
            o_plate: o_plate,
            // o_color: o_color,
            // o_power: o_power,
            o_engine: o_engine,
            o_chassis: o_chassis,
            // o_weight: o_weight,
            // o_seats: o_seats,
            // a_used: a_used,
            // a_type: a_type,
            // c_insured: c_insured,
            // c_curren: c_curren,
            // c_tex: c_tex,
            // a_premuim: a_premuim,
            // a_discount: a_discount,
            // a_net_premuim: a_net_premuim,
            // h: h,
            // i: i,
            // c_premuim: c_premuim,
            // c_discount: c_discount,
            // c_net_premuim: c_net_premuim,
            premuim: premuim,
            vat: vat,
            register: register,
            total_premuim: total_premuim,
            start: sent_startCover,
            end: sent_endCover,
            cover: cover,
            user_add: user_id,
            dateadd: Date.now(),
            emp_paid: emp_paid,
            driver_id: typedriver
        }
        // console.log(dataSetForGet)

        function setWhenUpdate(result) {
            if (result.data.fieldCount === 0) {
                setmodalsave(false)
                notification['success']({
                    message: 'ແຈ້ງເຕືອນ',
                    description: 'ບັນທຶກຂໍ້ມູນສຳເຫຼັດ'
                });
                setTimeout(() => {
                    // const win = window.open(`${l}/DocLong/${result.data.insertId}`, "_blank");
                    // win.focus();               
                    getOneData(result.data.insertId)
                    // console.log(result)
                }, 500);
            } else {
                setmodalsave(false)
                alert(JSON.stringify(result))
            }
        }

        if (sent_startCover === undefined || sent_endCover === undefined) {
            setmodalsave(false)
            notification['error']({
                message: 'ແຈ້ງເຕືອນ',
                description: 'ກະລຸນາກວດສອບວັນທີການຄຸ້ມກັນ'
            });
        } else {
            // console.log(dataSetForGet)
            // getOneData(242)
            form.resetFields()
            postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
        }

    }


    function getOneData(policy_no) {
        setloadingPDF(true)
        let link = `${ip}sell_online/getOne`
        let dataSetForGet = { no: policy_no, user: user_id }
        function setWhenUpdate(result) {
            if (result.data.status === 200) {
                setdatasentPDF(result.data.rows[0])
                // console.log(result.data.rows[0])
                setno(policy_no)
                setTimeout(() => {
                    setmodalShowPolicy(true)
                    // message.success(`ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
                    getOptionDriver(result.data.rows[0], setdrivercover_option)
                    getOptionThirtpaty()

                }, 1000);
            } else {
                setloadingPDF(false)
                message.success(`ບໍ່ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
            }
        }
        postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)
    }

    function onChange_v(v) {
        setvillageSelect(v.target.value)
    }

    function onChange_Car(value) {
        let v = JSON.parse(value)
        dataDriver.forEach(e => {
            if (e.driver_wheel === v.wheel) {
                set_typedriver(e.driver_id)
            }
        })


        seto_type(v.name)
    }

    useEffect(() => {

        if (sent_startCover !== '') {
            if (dayCover === '7d') {
                setsent_endCover(moment(sent_startCover).add(7, 'd').subtract(1, 'd'))
            } else if (dayCover === '15d') {
                setsent_endCover(moment(sent_startCover).add(15, 'd').subtract(1, 'd'))
            } else if (dayCover === '21d') {
                setsent_endCover(moment(sent_startCover).add(21, 'd').subtract(1, 'd'))
            } else if (dayCover === '1m') {
                setsent_endCover(moment(sent_startCover).add(1, 'months').subtract(1, 'd'))
            } else if (dayCover === '3m') {
                setsent_endCover(moment(sent_startCover).add(3, 'months').subtract(1, 'd'))
            } else if (dayCover === '6m') {
                setsent_endCover(moment(sent_startCover).add(6, 'months').subtract(1, 'd'))
            } else if (dayCover === '9m') {
                setsent_endCover(moment(sent_startCover).add(9, 'months').subtract(1, 'd'))
            }
        }
    }, [dayCover, sent_startCover])

    useEffect(async () => {
        let re = 20000
        let A, B, C, D
        A = total_premuim
        B = re
        C = (A - B) / 1.07
        D = C * 0.07

        setpremuim(C)
        setvat(D)


        // ຄິດໄລ່ຄ່າຂື້ນທະບຽນ-----------
        //   let r
        //   if (C <= 10000000) {
        //       r = 20000
        //   } else if (C <= 50000000) {
        //       r = 30000
        //   } else if (C <= 100000000) {
        //       r = 40000
        //   } else {
        //       r = 100000
        //   }
        //   setregister(r)

        setregister(B)



    }, [total_premuim])
    useEffect(() => {
        async function get() {
            let p = await getNamalData(ip + "address/pro")
            p.status === 200 && setprovice(p.data)


            // //ດິງຂໍ້ມູນລະຫັດຜູ້ຂັບຂີ່
            let dri = await getNamalData(ip + "sell_online/driver_tarif")
            dri.data.status === 200 && set_dataDriver(dri.data.data)


        }
        get()
        setDayCover('7d')
    }, [])

    useEffect(() => {
        async function _proviceid() {
            if (proviceid != null) {
                let l = ip + "address/dist/" + proviceid
                console.log(l)
                let d = await getNamalData(l)

                d.status === 200 && setdist(d.data)
            }

        }
        _proviceid()
      //  console.log("proviceid" ,proviceid)
    }, [proviceid])
    useEffect(() => {
        db.collection("ZJIS")
            .orderBy("no", "asc")
            .get()
            .then(result => {
                let d = []
                result.forEach(doc => {
                    d = ([...d, doc.data()])
                })
                setlistData(d)
            })
            .catch(e => console.log(e))
    }, [])
    useEffect(() => {
        // console.log(`A` + option + `-H-I3`)
        setcover(`A` + option + `-H-I3`)
    }, [option])



    return (
        <div>
            <MenuBar />
            
   
            <Form
                form={form}
                name="sellshot"
                // labelCol={{ span: 8 }}
                // wrapperCol={{ span: 16 }}
                initialValues={{ remember: true }}
                onFinish={submitForm}
                autoComplete="off"
            >
                <div className="container">
                    <Card className='C'>
                        <Divider orientation="left" plain>
                            ຂໍ້ມູນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ
                        </Divider>
                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: 2, paddingRight: 10 }}>
                                <Form.Item
                                    name="o_name"
                                    className='mb-0'
                                    rules={[{ required: false }]}
                                >
                                    <Input className='TI' placeholder="ຊື່ ແລະ ນາມສະກຸນ"
                                        onChange={(e) => {
                                            seto_name(e.target.value)
                                        }}
                                    />
                                </Form.Item>

                                <div className='row row-cols-1 row-cols-md-3'>
                                    <div className='col'>
                                        <Select
                                            placeholder="ເລືອກແຂວງ"
                                            optionFilterProp="children"
                                            onChange={onChange_pro}
                                            className='TI'
                                            style={{ width: '100%' }}
                                        >
                                            {
                                                provice.map((v) => {
                                                    return (
                                                        <Option key={v.provice_id} value={JSON.stringify(v)}>{v.provice_name}</Option>
                                                    )
                                                })
                                            }

                                        </Select>
                                    </div>
                                    <div className='col'>
                                        <Select
                                            placeholder="ເລືອກເມືອງ"
                                            optionFilterProp="children"
                                            onChange={
                                                onChange_dist
                                            }
                                            className='TI'
                                            style={{ width: '100%' }}
                                        >
                                            {
                                                dist.map((v) => {
                                                    return (
                                                        <Option key={v.dist_id} value={JSON.stringify(v)}>{v.dist_name}</Option>
                                                    )
                                                })
                                            }

                                        </Select>
                                    </div>
                                    <div className='col'>
                                        <Input className='TI' placeholder="ພິມຊື່ບ້ານ"
                                            onChange={onChange_v}
                                        />
                                    </div>
                                </div>




                                <Input className='TI' placeholder="ໂທລະສັບ"
                                    onChange={(e) => {
                                        seto_tel(e.target.value)
                                    }}
                                />
                                <Form.Item
                                    // label=" ເລືອກປະເພດລົດ::"
                                    name="o_type"
                                    rules={[{ required: true, message: 'ກະລຸນາເລືອກ  ເລືອກປະເພດລົດ ເສຍກ່ອນ' }]}
                                    className='mb-0'
                                >
                                    <Select
                                        placeholder="ປະເພດລົດ"
                                        optionFilterProp="children"
                                        onChange={onChange_Car}
                                        className='TI'
                                        style={{ width: '100%' }}
                                    >
                                        {
                                            listData.map((v) => {
                                                return (
                                                    <Option key={v.name} value={JSON.stringify(v)}>{v.name}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                                <Input className='TI' placeholder="ຫຍີ່ຫໍ້"
                                    onChange={(e) => {
                                        seto_make(e.target.value)
                                    }}
                                />
                                <Input className='TI' placeholder="ເລກທະບຽນ"
                                    onChange={(e) => {
                                        seto_plate(e.target.value)
                                    }}
                                />

                                <Input className='TI' placeholder="ເລກຈັກ"
                                    onChange={(e) => {
                                        seto_engine(e.target.value)
                                    }}
                                />
                                <Input className='TI' placeholder="ເລກຖັງ"
                                    onChange={(e) => {
                                        seto_chassis(e.target.value)
                                    }}
                                />
                                <Form.Item
                                    // label=" ເລືອກປະເພດລົດ::"
                                    name="total_premuim"
                                    rules={[{ required: true, message: 'ກະລຸນາເພີ່ມ ຄ່າທຳນຽມປະກັນໄພສຸດທ້າຍ ເສຍກ່ອນ' }]}
                                    className='mb-0'
                                >
                                    <Input type='number' className='TI' placeholder="ຄ່າທຳນຽມປະກັນໄພສຸດທ້າຍ"
                                        onChange={(e) => {
                                            settotal_premuim(e.target.value)
                                        }}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </Card>
                    <Card className='C'>
                        <Divider orientation="left" plain>
                            ທາາງເລືອກການຄຸ້ມກັນ
                        </Divider>
                        <div className='BDP'>
                            <div className='B1DP'>ເລືອກທາງເລືອກ ແລະ ຈຳນວນວັນຄຸ້ມກັນ</div>
                            <div className='B2DP'>
                                <Radio.Group onChange={(e) => {
                                    setOption(e.target.value)
                                }} value={option}>
                                    <Radio value={0}>ທາງເລືອກແບບບັງຄັບ</Radio>
                                    <Radio value={1}>ທາງເລືອກ 1</Radio>
                                    <Radio value={2}>ທາງເລືອກ 2</Radio>

                                </Radio.Group>

                            </div>
                        </div>
                        <br />
                    </Card>
                    <Card className='C'>
                        <Divider orientation="left" plain>
                            ທາາງເລືອກການຄຸ້ມກັນ
                        </Divider>
                        <div className='BDP'>
                            <div className='B1DP'>
                                <div className='row'>
                                    <Form.Item
                                        label="ວັນທີເລີ່ມຄຸ້ມກັນ::"
                                        name="start"
                                        rules={[{ required: true, message: 'ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ' }]}
                                    >
                                        <DatePicker
                                            placeholder='ວັນທີເລີ່ມຄຸ້ມກັນ'
                                            className='DP'
                                            showTime
                                            onChange={onChange_timestart}
                                            format={dateFormat}
                                            disabledDate={(current) => current.isBefore(moment().subtract(1, "day"))}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='B2DP'>
                                ຈຳນວນວັນຄຸ້ມກັນ
                                <div className='row'>
                                    <Radio.Group onChange={(e) => {
                                        setDayCover(e.target.value)
                                    }} value={dayCover}>
                                        <Radio value={'7d'}>7 Day</Radio>
                                        <Radio value={'15d'}>15 Day</Radio>
                                        <Radio value={'21d'}>21 Day</Radio>
                                        <Radio value={'1m'}>1 Month</Radio>
                                        <Radio value={'3m'}>3 Month</Radio>
                                        <Radio value={'6m'}>6 Month</Radio>
                                        <Radio value={'9m'}>9 Month</Radio>
                                    </Radio.Group>
                                </div>
                                <br />
                                <div className='row'>
                                    <div className='col-md-6'>

                                        {
                                            sent_startCover != '' && <>ວັນທີເລີ່ມຄຸ້ມກັນ  {(moment(sent_startCover).format(dateFormat))}</>
                                        }
                                    </div>
                                    <div className='col-md-6'>

                                        {
                                            sent_endCover != '' && <>ວັນທີສຶ້ນສຸດຄຸ້ມກັນ  {(moment(sent_endCover).format(dateFormat))}</>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Card>
                    <Card className='C'>
                        <Divider orientation="left" plain>
                            ຄິດໄລຄ່າທຳນຽມ
                        </Divider>
                        <div className='B'>
                            <div className='B1'> ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ </div>
                            <div className='B2'>{
                                premuim > 0 ? format(premuim) : 0
                            }</div>
                        </div>
                        <div className='B'>
                            <div className='B1'> ອາກອນມູນຄ່າເພີ່ມ </div>
                            <div className='B2'>{
                                vat > 0 ? format(vat) : 0
                            }</div>
                        </div>
                        <div className='B'>
                            <div className='B1'> ຄ່າຂື້ນທະບຽນ </div>
                            <div className='B2'>{
                                register > 0 ? format(register) : 0
                            }</div>
                        </div>
                        <div className='B'>
                            <div className='B1'> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
                            <div className='B2'>{
                                total_premuim > 0 ? format(total_premuim) : 0
                            }</div>
                        </div>
                    </Card>
                    <Card className='C'>
                        <Divider orientation="left" plain>
                            ການຊຳລະເງິນ
                        </Divider>
                        <div className='BDP'>
                            <div className='B1DP'>ສະຖານະການຊຳລະ</div>
                            <div className='B2DP'>
                                <Radio.Group onChange={(e) => {
                                    setemp_paid(e.target.value);
                                }} value={emp_paid}>
                                    <Radio value={0}>ລໍຖ້າການຊຳລະ</Radio>
                                    <Radio value={1}>ຊຳລະສົມບູນ</Radio>
                                </Radio.Group>

                            </div>
                        </div>
                    </Card>



                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ width: '100%' }}
                        >
                            ບັນທຶກຂໍ້ມູນ
                        </Button>
                    </Form.Item>

                </div>
            </Form>


            <Modal
                title="ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"
                visible={modalsave}
                onOk={createPolicy}
                onCancel={() => setmodalsave(false)}
                okText="ຕົກລົງ"
                cancelText="ຍົກເລີກ"
            >
                <div className='B'>
                    <div className='B1'> ຜູ້ໃດ້ຮັບການປະກັນໄພ </div>
                    <div className='B2'>{o_name}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ເລກທະບຽນ </div>
                    <div className='B2'>{o_plate}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ເລກຈັກ </div>
                    <div className='B2'>{o_engine}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ເລກຖັງ </div>
                    <div className='B2'>{o_chassis}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ການຄຸ້ມກັນ </div>
                    <div className='B2'>{cover}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ວັນທີເລີ່ມຄຸ້ມກັນ </div>
                    <div className='B2'>{(moment(sent_startCover).format(dateFormat))}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ວັນທີສຶ້ນສຸດຄຸ້ມກັນ </div>
                    <div className='B2'>{(moment(sent_endCover).format(dateFormat))}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
                    <div className='B2'>{format(total_premuim)}</div>
                </div>
                <div className='B'>
                    <div className='B1'> ສະຖານະການຈ່າຍເງິນ </div>
                    <div className='B2'> {emp_paid === 1 ? 'ຊຳລະສົມບູນ' : 'ລໍຖ້າການຊຳລະ'} </div>
                </div>
            </Modal>
            <Modal
                width={'720px'}
                title="ລາຍລະອຽດຂອງສັນຍາການຂາຍ"
                visible={modalShowPolicy}
                closable={false}
                // onOk={() => setmodalShowPolicy(false)}
                // onCancel={() => setmodalShowPolicy(false)}
                footer={[
                    <Button key="ກັບຄືນ" onClick={() => {
                        setloadingPDF(false)
                        setmodalShowPolicy(false)
                    }}>
                        ປິດ
                    </Button>,

                ]}
            >

                {/* <MakeDocLongFirst
                    no={no}
                    user={user}
                    oneData={datasentPDF}
                    thirdcover_option={thirdcover_option}
                    drivercover_option={drivercover_option}
                /> */}
                {
                    modalShowPolicy === true && <MakeDocLong
                        no={no}
                        user={user}
                        oneData={datasentPDF}
                        thirdcover_option={thirdcover_option}
                        drivercover_option={drivercover_option}
                    />
                }

            </Modal>
        </div>
    );
};





export default SellShot;

